import { createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { TeamMemberActions, TeamMemberActionTypes } from '../_actions/team-members.actions';
import { TeamMember } from '../_models/team-member.model';
import { QueryParamsModel } from '../../_base/crud';

// tslint:disable-next-line:no-empty-interface
export interface TeamMembersState extends EntityState<TeamMember> {
  totalCount: number;
  error: any;
  latestSuccessfullAction: any;
  listLoading: boolean;
  lastQuery: QueryParamsModel;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<TeamMember> = createEntityAdapter<TeamMember>();

export const initialTeamMembersState: TeamMembersState = adapter.getInitialState({
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  listLoading: false,
  lastQuery: new QueryParamsModel({}),
  showInitWaitingMessage: true,
});

export function teamMembersReducer(
  state = initialTeamMembersState,
  action: TeamMemberActions,
): TeamMembersState {
  switch (action.type) {
    case TeamMemberActionTypes.TeamMembersPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
      };
    case TeamMemberActionTypes.TeamMembersPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case TeamMemberActionTypes.TeamMembersPageLoaded: {
      return adapter.addMany(action.payload.teamMembers, {
        ...initialTeamMembersState,
        totalCount: action.payload.totalCount,
        showInitWaitingMessage: false,
        lastQuery: action.payload.page,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case TeamMemberActionTypes.ThrowTeamMemberError: {
      return {
        ...state,
        error: action.payload.error,
      };
    }
    case TeamMemberActionTypes.FireTeamMemberSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    case TeamMemberActionTypes.ClearMemberState: {
      return initialTeamMembersState;
    }
    default:
      return state;
  }
}

export const getTeamMemberState = createFeatureSelector<TeamMembersState>('teamMembers');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
